import ModelEntity from "../model-entity"
import CustomFieldsProxy from "../custom-fields-proxy"

import DatetimeUtils from "../../gd/utils/datetime-utils";
import TaskSave from "./actions/save";
import Moment, {Duration} from "moment"
import {EntityType} from "../../gd/const/item";
import {TaskProperties} from "./properties/properties";
import CRMAccountLookup from "../project/inheritance/crm-account";
import {Priority, ScheduleStatus} from "../../gd/types/types";
import {ACLRole} from "../../gd/access-control/user-roles";
import {taskCheckRole} from "./access-control/check-role";
import TimeReportsCollection from "../time-report/collection";
import {calculateDisplayEndDate, calculateDisplayStartDate} from "./functions/display-dates";
import {applyTaskDelta} from "./functions/delta";
import ExpensesCollection from "../expenses/expense/expenses";
import {selectTasks} from "../../gd/manager/delta-handler/session-events-handlers/task/select-task"
import {MyTimeCategory} from "../../../app/home/my-time/daily/model/const";
import {SystemStatus} from "../../gd/const/system-status";
import TodoManager from "./todo-manager";
import EntityCollection from "../entities-collection/entities-collection";
import Expense from "../expenses/expense/expense";
import {TaskAccessControl} from "./access-control/access-control";
import taskUpdateStartDate, {UpdateDateOptions} from "./actions/update-start-date";
import {taskAutoUpdateScheduleDate} from "./actions/auto-update-schedule";
import {taskUpdateSchedule} from "./actions/update-schedule";
import taskUpdateEndDate from "./actions/update-end-date";
import {taskDebugGantt} from "./actions/debug-gantt";
import taskUpdateStartEndDate from "./actions/update-start-end";
import taskSetCalendarDuration from "./actions/set-calendar-duration";
import WorkScheduleProto from "../../gd/manager/work-schedule/work-schedule-proto";
import taskSetWorkdayDuration from "./actions/set-workday-duration";
import {calculateCalendarDuration} from "../../gd/manager/start-end-duration/calculate-calendar-duration";
import {calculateWorkdayDuration} from "../../gd/manager/start-end-duration/calculate-workday-duration";
import taskAddUserAsActionRequired from "./actions/add-user/as-action-required";
import taskAddUserAsAssignee from "./actions/add-user/as-assignee";
import {calculateEstimatedLaborCost, calculateEstimatedServiceCost} from "./functions/estimated-cost";
import TaskType from "../task-type/task-type";
import ProjectSession from "../project/project-session";
import {SortDirection} from "../../data-structures/sort"
import MoveManger from "../../gd/manager/move-manager";
import CustomFieldsManager from "../../gd/manager/custom-fields-manager"
import MyWorkProto from "../my-work-properties/my-work-proto"
import MyWorkTaskActionRequired from "./my-work/task-action-required"
import MyWorkTaskDeadline from "./my-work/task-deadline"
import MyWorkTaskAssigned from "./my-work/task-assigned"
import {momentRange} from "../../gd/convert/moment-range";
import TaskProgressSubItems from "./task-view/helpers/progress-sub-items"
import {TaskMyWorkType, TaskSystemType, TypeModelOptions} from "./@types"
import {ProjectItemOrigin} from "../project-item/@type"
import {ProjectItem} from "../project-item/project-item"

// const debug = 'Task'
const debug = false

export default class Task extends ModelEntity {

    public isTemplate                   : boolean

    public companyId                    : ID
    public projectId                    : ID
    private _projects                   : ProjectItem[] = []                // multi project sypport !
    private _projectsMap?               : {[key: ID]: ProjectItem}
    private _defaultProject             : ProjectSession | null = null  // null = not cached
    public parentTaskId                 : ID | null
    // public sortPosition?                : number | null       // This is sort position we store in DB fo every task

    public title                        : string

    public taskTypeId                   : ID
    public systemType                   : TaskSystemType                     // - this oodl strange value 01 | 0 // task or subtask
    public shortId                      : number | string

    public statusId                     : ID
    public systemStatus                 : SystemStatus

    public actionRequiredUserId         : ID | null
    public actionRequiredSinceDate      : Moment | null
    private _scheduleStatus             : ScheduleStatus
    public scheduleDate                 : Moment | null                       // nado bilo private delat s geter and set...

    private _assignedToUserId           : ID | null

    public source                       : any
    public createdByUserId              : ID | null
    public createdOnBehalfByUserId      : ID | null
    public momentCreated                : Moment | null
    public momentClosed                 : Moment | null

    public deadline                     : Moment | null
    public _startDate                   : Moment | null
    public _endDate                     : Moment | null
    public priority                     : Priority  = 5 // 5 ? | null
    public progress                     : number | null
    public recurrency                   : { parentTaskId?: ID, date? : any, frequency?: number } | null //any

    public estimate                     : number | null
    public gmailMessageId               : ID | null

    public latestActivityMoment         : Moment | null

    // Advanced fields
    public users                        : any[] // it's array of task user models (!)
    declare customFieldsData             : CustomFieldsData //| null
    public tags                         : ID[] | null
    public storyPoints                  : number | null

    public _properties                  : TaskProperties | null    // json to store other data

    public _crmAccountId                : ID | null
    public _crmContactIds               : ID[] | null

    private _myWorkProps                : any   // MyWorkProto i.e.  MyWorkTaskActionRequired | MyWorkTaskAssigned ... etc need thinking for the type (!)
    private _myWorkType?                : TaskMyWorkType

    public isCrmAccountFromProject      : boolean

    // time reports related
    // etot field ne imeet render etc - t.e. netu field eto data only
    public timeReports                  : TimeReportsCollection
    public reportedTimeMinutes          : number | null   = null
    public costInternal                 : number | null   = null
    public costExternal                 : number | null   = null

    public attachmentsTotal?            : number    // total number of attachment used in list/table/etc views, *if not set = 0


    // gantt fields
    public _displayStartDate            : Moment | undefined       // these are based on task itself NOT based on children items !
    public _displayEndDate              : Moment | undefined

    // public duration?            : DurationDays //calculated in listItem - a eto kakoi ? calendar ? workday ? hmmmm stranno

    private _durationWorkday            : number | undefined | null     = undefined // undefined means calculation is required
    private _durationCalendar           : number | undefined | null     = undefined // undefined means calculation is required

    // Dependencies
    public predecessors                 : EntityCollection = new EntityCollection([])
    public successors                   : EntityCollection = new EntityCollection([])

    // Only set when this model *is* one side of a dependency, i.e. it was built from an entry of
    // another task's predecessors/successors. It is the id of the dependency record, not of a task.
    public dependencyId                 : ID | null = null


    // EXPENSES
    // tut zopa ... u project expenses number ... tut bila collection...
    // no po hodu ne uzalas' ???
    // temp collections / properties etc
    // public expenses?            : ExpensesCollection    // dont init here for now just be able to use
    public expenses                     : number
    public expensesCollection?          : ExpensesCollection

    public _myTimeCategory?             : MyTimeCategory        // used in my time view i.e. planned / active / viewed so we dont create a new model


    // this ones came from ItemModel (table, list)
    // public estimatedCostInternal?        : number    - use getters for now
    // public estimatedCostExternal?        : number    - use getters for now

    // public progressTasks?                  : number  // da, tol'ko dlya project
    public tasksTotal?                  : number    // what is it for ???  i think we dont' need it ? o0r we do ? see project model
    public tasksOpen?                   : number     // what is it for ???  i think we dont' need it ? o0r we do ? see project model
    public progressSubItems             : TaskProgressSubItems

    public todoList?                    : TodoManager

    public messagesTotal?               : number = undefined // used in Views to tell total number of messages (comments)

    public descriptionTxt               : string // is used in export to csv when description field is enabled

    private _taskAvailableCustomFields? : ID[]      // custom fields ids that can be set for this task

    constructor(data:any, options:TypeModelOptions={}) {
        super(data['id'], EntityType.TASK)

        this.isTemplate                 = _.get(data, 'isTemplate', false)

        this.companyId                  = data['companyId']
        this.projectId                  = data['projectId']

        this.sortPosition               = data['sortPosition']

        this.parentTaskId               = data['parentTaskId']

        this.title                      = data['title']

        if (!!data.projects?.[0]?.projectId) { // temporary fix, should always have projects with valid values in future
            this.projects               = _.map(data.projects, (data: any) => {
                return new ProjectItem(data, this)
            })
        } else {
            this.projects               = [new ProjectItem({
                projectId       : this.projectId,
                origin          : ProjectItemOrigin.MAIN,
                sortPosition    : this.sortPosition || 0
            }, this)]
        }

        this.taskTypeId                 = data['taskTypeId']
        this.systemType                 = data['systemType']
        this.shortId                    = data['shortId']

        this.statusId                   = data['statusId'] ? data['statusId'] : data['taskStatusId'] // taskStatusId is converted to statusId // required because task delta returns taskStatusId instead of statusId
        this.systemStatus               = data['systemStatus']

        this.actionRequiredUserId       = data['actionRequiredUserId']
        this.actionRequiredSinceDate    = data['actionRequiredSinceDate'] ? DatetimeUtils.datetimeToMoment(data['actionRequiredSinceDate']) : null
        this._scheduleStatus             = data['scheduleStatus']
        this.scheduleDate               = data['scheduleDate'] ? DatetimeUtils.dateToMoment(data['scheduleDate']) : null

        this._assignedToUserId          = data['assignedToUserId']

        this.source                     = data['source']
        this.createdByUserId            = data['createdByUserId']
        this.createdOnBehalfByUserId    = data['createdOnBehalfByUserId']

        // should be undefined if none for correct calculations (min, max and others)
        this.attachmentsTotal           = data['attachmentsTotal'] || undefined //_.get(data, 'attachmentsTotal', 0)

        // moment created support both momentCreated & dateCreated ...
        this.momentCreated              = null
        if (data['dateCreated']) this.momentCreated= DatetimeUtils.datetimeToMoment(data['dateCreated'])
        if (data['momentCreated']) this.momentCreated= DatetimeUtils.datetimeToMoment(data['momentCreated'])


        this.momentClosed               = data['momentClosed'] ? DatetimeUtils.datetimeToMoment(data['momentClosed']) : null

        this.deadline                   = data['deadline'] ? DatetimeUtils.dateToMoment(data['deadline']) : null
        this._startDate                 = data['startDate'] ? DatetimeUtils.dateToMoment(data['startDate']) : null
        this._endDate                   = data['endDate'] ? DatetimeUtils.dateToMoment(data['endDate']) : null
        this.priority                   = data['priority']
        this.progress                   = data['progress']
        this.recurrency                 = data['recurrency']

        this.estimate                   = data['estimate']
        this.gmailMessageId             = data['gmailMessageId']

        // supports both latest activityDate & latestActivityMoment
        this.latestActivityMoment       = null
        if (data['recentActivityMoment'])   this.latestActivityMoment = DatetimeUtils.datetimeToMoment(data['recentActivityMoment']) // gantt data returns recentActivityMoment
        if (data['latestActivityDate'])     this.latestActivityMoment = DatetimeUtils.datetimeToMoment(data['latestActivityDate'])
        if (data['latestActivityMoment'])   this.latestActivityMoment = DatetimeUtils.datetimeToMoment(data['latestActivityMoment'])
        // Advanced fields
        this.users                      = _.get(data, 'users', []) // NO! it's array of task user models (!)

        //created by can be empty - mom task
        if (!this.createdByUserId && !_.isEmpty(this.users)) {
            let createdByUser       = _.find(this.users, u=> u.taskRole === gd.const.task.role.CREATOR)
            this.createdByUserId    = createdByUser ? createdByUser.userId : null
        }

        this.customFieldsData           = data['customFieldsData'] || {}
        this.tags                       = data['tags']    // array of tag ids
        this.storyPoints                = data['storyPoints']
        this.messagesTotal              = data['messagesTotal'] || undefined

        this._properties                = new TaskProperties(data['properties'])    // json to store other data

        this._crmAccountId              = data['crmAccountId']
        this.isCrmAccountFromProject    = false  // set to true if was redefined by project
        this._crmContactIds             = data['crmContactIds']

        this.expenses                   = data['expenses'] || this._properties.expensesTotal || 0

        this.descriptionTxt             = data['descriptionTxt']

        // TIME REPORTS
        this.timeReports                = TimeReportsCollection.initFromJson(data['timeReports'])
        this.reportedTimeMinutes        = data['reportedTimeMinutes'] || data['reportedTime']   // #oldk290 reportedTimeMinutes is right name for task model on client

        // Need fix
        // if (!this.reportedTimeMinutes && data.reportedTime) {
        //     console.warn("old API data format ? need fix on backend #kdjdie")
        // }

        this._myTimeCategory            = data['myTimeCategory']

        // present on the entries of a predecessors/successors array, never on a task in its own right
        this.dependencyId               = data['dependencyId'] || null

        if (data.predecessors)  {
            // this.predecessors   = EntityCollection.initFromJson(data.predecessors)
            this.predecessors.addTasksFromJson(data.predecessors)
        }

        if (data.successors)    {
            // this.successors     = EntityCollection.initFromJson(data.successors)
            this.successors.addTasksFromJson(data.successors)
        }

        this._displayStartDate   = data['displayStartDate'] ? DatetimeUtils.dateToMoment(data['displayStartDate']) : undefined
        this._displayEndDate     = data['displayEndDate'] ? DatetimeUtils.dateToMoment(data['displayEndDate']) : undefined
        // if (!this.displayStartDate || !this.displayStartDate) calculateDisplayDates(this)


        if (!this.projectId && data.parentId) {
            console.warn("old API data format ? need fix on backend #kd343jdie")
            this.projectId = data.parentId
        }

        this.progressSubItems   = new TaskProgressSubItems(data)

        // hm...
        this.todoList = new TodoManager({taskId: this.id}, {add: false, edit: false}, data.todoList)

        // task recurrence
        if (data.taskRecurrencyDate || data.taskRecurrencyParentTaskId) {
            this.recurrency = {}
            if (data.taskRecurrencyDate)         this.recurrency.date = data.taskRecurrencyDate
            if (data.taskRecurrencyParentTaskId) this.recurrency.parentTaskId = data.taskRecurrencyParentTaskId
        }

        // yes need it...
        this.initCrmAccountInheritance()

        //
        this.costInternal       = this.timeReports.costInternal
        this.costExternal       = this.timeReports.costExternal


        // this.calculateTimeReportFieldsFromCollection()

        debug && console.log(debug, "constructor", this.title, this._properties, data['properties'])

        const useProxy      = _.get(options, 'useProxy', true)
        this._myWorkType    = _.get(options, 'myWorkType', undefined)

        return useProxy ? new Proxy(this, CustomFieldsProxy) : this;
    }

    static async initById(id:ID, requiredParams = {
        id              : true,
        tags            : true,
        timeReports     : true,
        taskUsers       : true,
        predecessors    : true,
        successors      : true,
        messagesTotal   : true,
        attachmentsTotal: true,
        crm             : true
    }) {
        const selectedTasks = await selectTasks([id], requiredParams)
        return selectedTasks[0] ? new Task(selectedTasks[0]) : null
    }

    // ACCESS

    get acl():TaskAccessControl {
        return new TaskAccessControl(this)
    }

    get defaultProject(): ProjectSession {
        // If already determined, return cached default project
        if (this._defaultProject !== null) {
            return this._defaultProject
        }

        // Find the main (origin: MAIN) project item for this task, if any
        const mainItem = _.find(this.projects, (projectItem: ProjectItem) => {
            return projectItem.origin === ProjectItemOrigin.MAIN
        })
        const mainProjectId = mainItem?.projectId ?? this.projectId
        const mainProject = gd.session.projects.get(mainProjectId)

        // If the user has at least LIMITED access to the main project, use it as default
        if (mainProject && mainProject.access >= gd.const.project.access.LIMITED) {
            this._defaultProject = mainProject
            return this._defaultProject
        }

        // No access to main project

        let bestProject: ProjectSession
        let bestAccess = -Infinity

        // Scan for the linked project with the highest access level
        _.each(this.projects, (projectItem: ProjectItem) => {
            // Skip the main origin -- we've already considered it above
            if (projectItem.origin === ProjectItemOrigin.MAIN) return

            const project = gd.session.projects.get(projectItem.projectId)
            if (project && project.access > bestAccess) {
                bestAccess  = project.access
                bestProject = project
            }
        })

        // Set the default project to the best found, or if none, fallback to mainProject (even if access is insufficient)
        this._defaultProject = bestProject! ?? mainProject!
        return this._defaultProject
    }

    resetDefaultProject() {
        this._defaultProject = null
    }

    quickSearch(quickSearchValueNormalized:string):boolean {
        return  this.shortId === quickSearchValueNormalized ||
                this.title.toLowerCase().includes(quickSearchValueNormalized)
    }

    // SYSTEM

    get isNewlyCreated():boolean {
        return !this.id
    }

    get myWorkProps():MyWorkProto {
        if (!this._myWorkProps) {
            switch (this._myWorkType) {
                case TaskMyWorkType.ACTION_REQUIRED:
                    this._myWorkProps = new MyWorkTaskActionRequired(this)
                    break

                case TaskMyWorkType.ASSIGNED_TO:
                    this._myWorkProps = new MyWorkTaskAssigned(this)
                    break

                case TaskMyWorkType.DEADLINE:
                    this._myWorkProps = new MyWorkTaskDeadline(this)
                    break
            }
        }

        return this._myWorkProps
    }

    // DISPLAY DATES

    get displayStartDate():Moment {
        if (this._displayStartDate===undefined) {
            this._displayStartDate = calculateDisplayStartDate(this)
        }
        return this._displayStartDate
    }

    set displayStartDate(value:Moment) {
        this._displayStartDate = value
    }

    get displayEndDate():Moment {
        if (this._displayEndDate===undefined) {
            this._displayEndDate = calculateDisplayEndDate(this)
        }
        return this._displayEndDate
    }

    set displayEndDate(value:Moment) {
        this._displayEndDate = value
    }


    // DATES

    get startDate() { return this._startDate }
    get endDate() { return this._endDate }

    set startDate(value:Moment|null) {
        this._startDate = value
        this.updatedFields.add('startDate')
        this.onFieldChange('startDate', value)
    }

    set endDate(value:Moment|null) {
        this._endDate = value
        this.updatedFields.add('endDate')
        this.onFieldChange('endDate', value)
    }

    // need for filter at least
    get startEnd():MomentRange|null {

        // no dates ? -> return null
        if (!this.startDate || !this.endDate) {
            return null
        }

        return momentRange(this.startDate, this.endDate)
    }


    updateStartDate(startDate:Moment|null, options:UpdateDateOptions={}) {
        taskUpdateStartDate(this, startDate, options)
        // this = Task WITHOUT proxy so we need manaully update start end dates
        this.updatedFields.add('startDate')
        this.updatedFields.add('endDate')
    }

    updateEndDate(endDate:Moment|null) {
        taskUpdateEndDate(this, endDate)
        // this = Task WITHOUT proxy so we need manaully update start end dates
        this.updatedFields.add('startDate')
        this.updatedFields.add('endDate')
    }

    updateStartEnd(startDate:Moment|null, endDate:Moment|null) {
        taskUpdateStartEndDate(this, startDate, endDate)

        // this = Task WITHOUT proxy so we need manaully update start end dates
        this.updatedFields.add('startDate')
        this.updatedFields.add('endDate')
    }

    // SCHEDULE

    autoUpdateScheduleDate() {
        taskAutoUpdateScheduleDate(this)
    }

    updateSchedule(scheduleDate:Moment|null, scheduleStatus:ScheduleStatus) {
        taskUpdateSchedule(this, scheduleDate, scheduleStatus)
        // this = Task WITHOUT proxy so we need manaully update start end dates
        this.updatedFields.add('scheduleStatus')
        this.updatedFields.add('scheduleDate')
    }

    get scheduleStatus() { return this._scheduleStatus }
    set scheduleStatus(scheduleStatus:ScheduleStatus) {
        this._scheduleStatus = scheduleStatus
    }

    get estimateHours():number {
        if (!this.estimate) return 0

        return this.estimate / 60
    }

    // DURATION

    get workSchedule():WorkScheduleProto {

        if (this.assignedToUserId) {
            return gd.workSchedule.getUserWorkSchedule(this.assignedToUserId)
        }

        return gd.workSchedule.getCompanyWorkSchedule()
    }

    get durationWorkdays(): number | null {
        if (this._durationWorkday===undefined) this._durationWorkday = calculateWorkdayDuration(this.startDate, this.endDate, this.assignedToUserId)
        return this._durationWorkday || null
    }

    set durationWorkdays(value : number | null) {
        taskSetWorkdayDuration(this, value)
    }

    get durationCalendar(): number | null {
        if (this._durationCalendar===undefined) this._durationCalendar = calculateCalendarDuration(this.startDate, this.endDate)
        return this._durationCalendar
    }

    set durationCalendar(value:number | null) {
        taskSetCalendarDuration(this, value)
    }

    // USERS

    get assignedToUserId() { return this._assignedToUserId }
    set assignedToUserId(userId:ID|null) {
        this._assignedToUserId = userId
        this.updatedFields.add('assignedToUserId')
        this.onFieldChange('assignedToUserId', userId)
    }



    // DYNAMIC PROPERTIES

    // Ok for now let's calculate it ewvery time ... but it's not very good I guess we use calculated values anyway
    get estimatedCostInternal(): number | undefined {
        if (!this.estimate) {
            return undefined
        }

        if (!gd.ac.check.company.isManager()) {
            return undefined
        }

        return calculateEstimatedLaborCost(this)
    }

    get estimatedCostExternal(): number | undefined {
        if (!this.estimate) {
            return undefined
        }

        if (!gd.ac.check.company.isManager()) {
            return undefined
        }

        // return gd.ac.check.company.isManager() ? calculateEstimatedCost(this.estimate, this.assignedToUserId).estimatedCostExternal : 0
        return calculateEstimatedServiceCost(this)
    }

    get link():string {
        return 'https://www.goodday.work/t/{0}'.f(this.id)
    }

    get isSubtask():boolean {
        return this.systemType === TaskSystemType.SUBTASK
    }

    get timeReported() {
        // ingoda smotrim po reportedTimeminutes -> ingoda po collection
        let timeReported : number = 0

        if (this.reportedTimeMinutes)   {
            timeReported = this.reportedTimeMinutes
        }
        if (!this.timeReports.isEmpty)  {
            timeReported = this.timeReports.totalReportedTime
        }

        return timeReported
    }

    get spentEstimate():number | undefined {

        if (!this.estimate) return undefined

        const timeReported = this.timeReported
        if (!timeReported) return 0

        return Math.floor(100 * timeReported / this.estimate)
    }


    initCrmAccountInheritance() {
        // added by Vic Mar 9 2023
        // idea: if project has crm account all tasks should be displayed as this account

        // if already set somehow - we redefine it !
        // const project = gd.session.projects.get(this.projectId)
        // if (!project) return

        const crmAccountLookup = new CRMAccountLookup(this.projectId)
        const crmAccountId = crmAccountLookup.get()

        if (crmAccountId) {
            this._crmAccountId              = crmAccountId
            this.isCrmAccountFromProject    = true

            // leave only crmContactIds that belong to current crmAccountId
            if (!_.isEmpty(this.crmContactIds)) {
                const crmAccountContactIds: ID[] = []
                _.map(gd.session.crmContacts.models, model=>{
                    if (model.crmAccountId === crmAccountId) crmAccountContactIds.push(model.id)
                })

                this._crmContactIds = _.intersection(this._crmContactIds, crmAccountContactIds)
            }
        }

    }

    _applyRecurrencyDelta(key:string, value:any) {
        if (!this.recurrency) this.recurrency = {}

        let isChanged = false
        if (key === 'taskRecurrencyParentTaskId') {
            const recurrencyParentTaskId = _.get(this.recurrency, 'parentTaskId')
            if (!_.isEqual(recurrencyParentTaskId,value)) {
                this.recurrency['parentTaskId'] = value;
                isChanged = true
            }
        }

        if (key === 'taskRecurrencyDate') {
            const recurrencyDate = _.get(this.recurrency, 'date')
            if (!_.isEqual(recurrencyDate,value)) {
                this.recurrency['date'] = value;
                isChanged = true
            }
        }

        if (_.isEmpty(this.recurrency['parentTaskId'])) delete this.recurrency['parentTaskId']
        if (_.isEmpty(this.recurrency['date']))         delete this.recurrency['date']
        if (_.isEmpty(this.recurrency))                 this.recurrency = null

        return isChanged
    }

    applyDelta(data:any) {
        return applyTaskDelta(this, data)
    }

    // Dynamic properties

    // alias - used in table/list
    get taskStatusId():ID {
        return this.statusId
    }

    // issues in time reports
    get name() {
        return this.title
    }

    get isOpen():boolean {
        return gd.const.systemStatus.isOpen(this.systemStatus);
    }

    get isClosed():boolean {
        return !this.isOpen
    }

    get isDeadlineToday():boolean {
        if (!this.isOpen || !this.deadline) return false

        if (moment().isSame(this.deadline, 'days')) return true

        return false
    }

    get isDeadlinePastdue():boolean {
        if (!this.isOpen || !this.deadline) return false
        if (moment().isAfter(this.deadline, 'days')) return true

        return false
    }

    get isPastdueDeadline() {
        return this.deadline && DatetimeUtils.isBeforeToday(this.deadline)
    }

    get isPastdueEndDate() {
        return this.endDate && DatetimeUtils.isBeforeToday(this.endDate)
    }

    get isEndDateToday():boolean {
        if (!this.isOpen || !this.endDate) return false
        if (moment().isSame(this.endDate, 'days')) return true

        return false
    }

    get isEndDatePastdue():boolean {
        if (!this.isOpen || !this.endDate) return false
        if (moment().isAfter(this.endDate, 'days')) return true

        return false
    }

    get leadTime(): Duration {
        const latestDate = this.isOpen ? moment() : this.momentClosed
        const secondsAgo = latestDate!.diff(this.momentCreated,"seconds")
        return moment.duration(secondsAgo, 'seconds')
    }

    get age(): Duration {
        const secondsAgo = moment().diff(this.momentCreated,"seconds")
        return moment.duration(secondsAgo, 'seconds')
    }

    get allUsers(): ID[] {
        return _(this.users)
            .map((u: any)=>{
                return u.userId
            })
            .orderBy((id: ID) => {
                if (id === this.actionRequiredUserId)   return 2
                if (id === this.assignedToUserId)       return 1
                return 0
            }, SortDirection.DESC)
            .value()
    }

    // GETTERS & SETTERS
    get properties() { return this._properties }
    set properties(value) {
        // a pochemu deprecated ? navernoe es't prichnina no kakaya ? stranno ...
        // stop eto imenno setter !
        console.error("this is depricated #9485904 OCHEN: nado razobratsya " )
        this._properties = new TaskProperties(value)
    }

    get crmAccountId() {
        return this._crmAccountId;
    }

    set crmAccountId(crmAccountId) {
        this._crmAccountId = crmAccountId;
        this._normalizeCrmData();
    }

    get crmContactIds() {
        return this._crmContactIds;
    }

    set crmContactIds(crmContactIds) {
        // chto nahoditsya v pervom no ne vo vtorom
        // poluchaem massiv novih contacts

        // @ts-ignore
        const addedContactIds = _.difference(crmContactIds, this._crmContactIds);

        this._crmContactIds = crmContactIds;

        // auto set CRM Account based on Contact
        if (_.isNil(this._crmAccountId)) {
            // auto set account id
            _.some(addedContactIds, (contactId)=>{
                // select account id according to added contactId
                const accountId = gd.session.crmContacts.get(contactId).crmAccountId;
                // etot account okazivaetsya mozet bit' deleted... wow...
                if (accountId && gd.session.crmAccounts.get(accountId)) {
                    this._crmAccountId = accountId;
                    this.updatedFields.add('crmAccountId');
                    return true;
                }
            })
        }

        this._normalizeCrmData();
    }

    get calculatedExpenses() {
        return this.expensesCollection?.total //|| 0
    }

    public resetCostFields() {

        this.costInternal       = this.timeReports.costInternal
        this.costExternal       = this.timeReports.costExternal

        // estimatedCostInternal .... they are getters still
    }

    public calculateTimeReportFieldsFromCollection() {

        if (!this.timeReports) {
            console.warn("no timeReports passed #dkdjs93")
            return
        }
        if (this.timeReports instanceof TimeReportsCollection) {
            // i.e. list / table
            this.reportedTimeMinutes    = this.timeReports.totalReportedTime
            this.costInternal           = this.timeReports.costInternal
            this.costExternal           = this.timeReports.costExternal
        } else {
            // nado razobratsya gde eto govno uzaetsya...
            const collection            = new TimeReportsCollection(this.timeReports)
            this.reportedTimeMinutes    = collection.totalReportedTime
            this.costInternal           = collection.costInternal
            this.costExternal           = collection.costExternal
        }
        // this.reportedTimeMinutes = this.timeReports
    }

    get taskType():TaskType | null {
        return gd.session.taskTypes.get(this.taskTypeId)
    }

    get availableCustomFieldsIds(): ID[] {
        if (!this._taskAvailableCustomFields) {
            const taskAvailableCustomFields = CustomFieldsManager.getTaskViewCustomFields(this.taskTypeId, this.projectsIds)
            this._taskAvailableCustomFields = taskAvailableCustomFields.map(cf=>cf.id)
        }

        return this._taskAvailableCustomFields
    }

    // Data normalizers
    _normalizeCrmData() {

        // smotrim esli est' account
        if (!_.isNil(this._crmAccountId)) {

            const account = gd.session.crmAccounts.get(this._crmAccountId)
            if (!account) return

            // ubiraem vse contacts ne iz etogo account

            const filteredContactIds : ID[] = _.filter(this._crmContactIds, (id:string)=>{
                // contact can be not found i.e. deleted
                return gd.session.crmContacts.get(id)?.crmAccountId === this._crmAccountId
            });

            this._crmContactIds = filteredContactIds
            this.updatedFields.add('crmContactIds');
        }
    }

    toJSON(skipProperties: string[] = []): JSONObject {
        let res: JSONObject = {}

        _.mapKeys(this, (value:any, key)=>{
            if (skipProperties.includes(key)) {
                return
            }

            switch (key) {
                case 'actionRequiredSinceDate'  :
                    res[key] = DatetimeUtils.momentToUTCISODatetime(value)
                    break

                case 'latestActivityMoment'     :
                    res[key] = DatetimeUtils.momentToUTCISODatetime(value)
                    res['latestActivityDate'] = res[key]
                    break

                case 'scheduleDate'             :
                case 'deadline'                 :
                case 'startDate'                :
                case 'endDate'                  :
                    res[key] = value ? DatetimeUtils.momentToDate(value) : null
                    break

                case 'momentCreated'            :
                    res[key] = value ? DatetimeUtils.momentToUTCISODatetime(value) : null
                    res['dateCreated'] = res[key]
                    break

                // causes circular toJSON if not empty
                // chto to ne poimu zachem eto tut - no vozmozno nado....
                case 'successors'               :
                case 'predecessors'             :
                    res[key] = []
                    break

                default                         :
                    if (key.substring(0,1) === '_') key = key.substring(1)
                    res[key] = value && value.toJSON ? value.toJSON() : value
            }

        })

        // Use cloneDeep to prevent direct modification of this model's values (e.g. this.projects)
        return _.cloneDeep(res)
    }

    public aclRole(role:ACLRole) {
        return taskCheckRole(this, role)
    }

    // ACTIONS ...

    addUserAsActionsRequired() { return taskAddUserAsActionRequired(this) }

    addUserAsAssignee() { return taskAddUserAsAssignee(this) }

    addUser() {
        // ???
    }


    // Data management

    save() {
        return new TaskSave(this)
    }

    public clone(options?:TypeModelOptions):Task {
        return new Task(this.toJSON(), options)
    }



    ///
    // gant patch - this is deprecated
    get recentActivityMoment() {
        // console.warn("recentActivityMomentDepricated")
        return this.latestActivityMoment
    }

    // required for applyTaskDelta to work correctly as
    // Reflect.has(object, 'reportedTime') is true because of getter
    // but without setter `object['reportedTime'] = value` causes error
    set reportedTime(value) {
        this.reportedTimeMinutes = value
    }

    // Deprecated !
    get reportedTime() {
        // console.warn("reportedTime is depricated")
        return this.reportedTimeMinutes
    }

    get isActionRequiredEnabled():boolean {
        return this.taskType!.settings.isActionRequiredEnabled
        // return true
    }

    get parentId():ID {
        return this.projectId
    }

    // we need this field for project path
    get projectPath():ID {
        return this.projectId
    }

    get projectType() {
        const project: ProjectSession | null = gd.session.projects.get(this.projectId)

        if (!!project) {
            return project.localTemplateId ? project.localTemplateId : project.systemType
        }
    }

    get datesForDependency() {

        if (this.startDate && this.endDate) {
            return {
                start   : this.startDate,
                end     : this.endDate
            }
        }

        return {
            start   : this.displayStartDate,
            end     : this.displayEndDate
        }

    }

    setAR(id: ID) {
        const curAR = _.find(this.users, u=>u.id === this.actionRequiredUserId);
        if (curAR) curAR.taskRole = gd.const.task.role.COLLABORATOR;

        this.actionRequiredUserId = id;
        this.scheduleStatus = gd.const.task.scheduleStatus.NOT_SCHEDULED;
        this.scheduleDate = null;

        // id can be null
        if (id && !_.find(this.users, u=>u.userId === id)) {

            if (!this.users) return // prevent null case

            this.users.unshift({ taskRole: gd.const.task.role.ASSIGNEE, userId: id });
        }

    }

    setAssignedToUser(id : ID|null) {
        const curAssignedToUser = _.find(this.users, u=>u.id === this.assignedToUserId);
        if (curAssignedToUser) curAssignedToUser.taskRole = gd.const.task.role.COLLABORATOR;

        this.assignedToUserId = id;

        // id can be null
        if (id && !_.find(this.users, u=>u.userId === id)) {
            if (!this.users) return // prevent null case
            this.users.unshift({ taskRole: gd.const.task.role.COLLABORATOR, userId: id });
        }

    }

    // is used in TaskView_SubtasksTree
    setSortPosition(sortPosition:number): void {
        this.sortPosition = sortPosition;
    }

    get projects(): ProjectItem[] {
        return this._projects
    }

    set projects(value: ProjectItem[]) {
        this._projects = _.uniqBy(value, (item: ProjectItem) => item.projectId)
        this.resetProjectsMap()
        this.resetDefaultProject()
    }

    get projectsMap() {
        if (!this._projectsMap) {
            this._projectsMap = _.keyBy(this._projects, 'projectId')
        }

        return this._projectsMap
    }

    resetProjectsMap() {
        this._projectsMap = undefined
    }

    isMainProject(projectId: ID) {
        return this.projectsMap[projectId]?.origin === ProjectItemOrigin.MAIN
    }

    isInProject(projectId: ID): boolean {
        return !!this.projectsMap[projectId]
    }

    get isMultiProject(): boolean {
        return this.projects.length > 1
    }

    setProjectSortPosition(projectId: ID, sortPosition: number) {
        const projectItem = this.projectsMap[projectId]
        if (projectItem) {
            projectItem.sortPosition = sortPosition
        }

        // probably this.sortPosition is redundant but keep it for now
        if (this.isMainProject(projectId)) {
            this.sortPosition = sortPosition
        }
    }

    /*getProjectSortPosition(projectId?: ID) {
        let res
        if (projectId) {
            res = this.projectsMap[projectId]?.sortPosition
        }
        return res || this.sortPosition || 0
    }*/

    setStoryPoints(value:number|null) {
        this.storyPoints = value;
    }

    get myTimeCategory():MyTimeCategory {


        if (this.timeReports && !this.timeReports.isEmpty) {
            return MyTimeCategory.ACTIVE_TASK
        } else if (this._myTimeCategory) {
            return this._myTimeCategory
        } else {
            // it can happen !!! when we recieve actrive tasks without time reports
            // e.g. no time reports yet
            return MyTimeCategory.ACTIVE_TASK
        }

    }

    // be carefull - we dont' cache it because dont' have setter for projectId yet
    get project():ProjectSession | null {
        return gd.session.projects.get(this.projectId)
    }

    get url():string {
        return "t/" + this.id;
    }


    setCustomFieldValue(customFieldId:ID, value:any) {
        // @ts-ignore
        this[customFieldId] = value

    }

    // DEBUG

    get debugName() {
        return "task "+this.title
    }

    debugGantt():void { taskDebugGantt(this) }


    // ACTIONS

    copyUrl() {
        gd.utils.copyToClipboard(this.link)
        gd.growl.success("{0} link copied to clipboard".f(this.title))
    }

    minimizeToTRay() {
        gd.taskTray.add(this.id, this.title)
    }

    openNewWindow():void {
        gd.openInNewWindow('/t/{0}'.f(this.id))
    }

    rename() {

        // yes current view updated via session udpate

        gd.modals.oneInput('Title', this.title, 'Rename task', (newTitle:string)=>{
            gd.modal.hide()
            gd.api.Task.editTitle(this.id, newTitle)
        })
    }

    moveToTask (callback?:callback){
        gd.modals.task.moveToTask(this, ()=>{
            if (callback) callback()

        })
    }

    convertToTask(callback?:callback) {

        // this.projectId ? this.projectId : this.parentId - old
        if (!this.projectId) {
            console.error("#9023ee82387 cant move task no project passed")
            return
        }

        // move to current projectId
        MoveManger.moveAndSortTaskToProject(this.id, this.projectId, [], undefined, () => {
            if (callback) callback() // notify app that we moved something
        })
    }

    addToProject(callback?:callback) {
        if (!this.projectId) {
            console.error("Task addProject: task has no project")
            return
        }

        gd.modals.task.addTaskToProject(this, (project: ProjectSession) => {
            callback?.() // notify app that we added projects
        })
    }

    // convertTaskType () {
    //     gd.modals.task.convertTaskType(
    //         this,
    //         (taskType, taskStatus)=>{
    //             const data: any = {
    //                 id          : this.id,
    //                 taskTypeId  : taskType
    //             }
    //             if (taskStatus) data.statusId = taskStatus
    //
    //             if (props.onEdit) props.onEdit(data)
    //         },
    //         props.onBeforeApiCall
    //     )
    // }

    // END


    private _isSameValue(paramName:string, value:any):boolean {
        // @ts-ignore
        if (Moment.isMoment(this[paramName])) {
            // console.log("isSameValue", DatetimeUtils.momentToDate(this[paramName]), DatetimeUtils.dateTruncTime(value), DatetimeUtils.isSame(this[paramName], DatetimeUtils.dateToMoment(value), 'day'))
            // @ts-ignore
            return DatetimeUtils.isSame(this[paramName], DatetimeUtils.dateToMoment(value), 'day')
        } else {
            // @ts-ignore
            return _.isEqual(this[paramName],value)
        }
    }

    goTo() {
        gd.navigation.goToTask(this.id)
    }


    public addExpense(expense:Expense):void {
        if (!this.expensesCollection) this.expensesCollection = new ExpensesCollection()

        this.expensesCollection.add(expense)
    }

    onFieldChange(field:string, newValue:any) {

        switch (field) {

            case 'startDate':
            case 'endDate':
            case 'assignedToUserId':
                this._durationCalendar  = undefined
                this._durationWorkday   = undefined
                this._displayStartDate  = undefined
                this._displayEndDate    = undefined
                return

            default:
                return
        }
    }

    checkDataForMorePopover() {

        // tut netu adekvatnoi provekri po parentTaskId - na sammom delete dumay systemType nuzen
        // seichas on tutpo esli undefined schitaet chto ne subtask

        if (!this.title || !this.projectId /*|| !this.shortId*/ || !this.taskTypeId) {
            console.error("#048478dj3 - not enough data to build task more menu")
        }

    }

    get userIds() {
        return _.map(this.users, user=>user.userId)
    }

    get teamIds() {
        // not implemented yet
        return []
    }

    get projectsIds() {
        return _.map(this._projects, (projectItem: ProjectItem) => {
            return projectItem.projectId
        })
    }

    // Checks if this task belongs to any of the provided projects
    isInProjectIds(projectIds: ID[]): boolean {
        return _.intersection(this.projectsIds, projectIds).length > 0;
    }
}
